import { createSlice } from "@reduxjs/toolkit";

const assistantSlice = createSlice({
  name: "assistant",
  initialState: {
    isOpen: false,
  },
  reducers: {
    openAssistant(state) {
      state.isOpen = true;
    },
    closeAssistant(state) {
      state.isOpen = false;
    },
    toggleAssistant(state) {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { openAssistant, closeAssistant, toggleAssistant } = assistantSlice.actions;
export default assistantSlice.reducer;
